import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import {FOODIE_MENU_SERVICE} from "../EndPoints";
const serviceName = 'foodie-menu-service';


/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
export const CreateExtraMeal = createAsyncThunk('extraMeal/CreateExtraMeal', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(`${serviceName}/v2/orders/create`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const GetExtraOrders = createAsyncThunk('extraMeal/GetExtraOrdersByAdmin ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(`${serviceName}/v2/extra/orders/search`, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status, code } = response;
    return { data, status, code };
});

export const GetActiveExtraOrders = createAsyncThunk('extraMeal/getActiveExtraOrders ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(FOODIE_MENU_SERVICE.getActiveExtraOrders, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status, code } = response;
    return { data, status, code };
});

export const UpdateExtraOrders = createAsyncThunk('extraMeal/UpdateExtraOrders ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .put(`${serviceName}/v2/orders/update`, params)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetFoodieUserMenuSelections = createAsyncThunk(
    'extraMeal/GetFoodieUserMenuSelections ',
    async (userId, currentDate, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`/v1/app/get/by-user-id/${userId}/${currentDate}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const RetrievesAQrCodeBody = createAsyncThunk(
    'extraMeal/RetrievesAQrCodeBody ',
    async (id, { dispatch, getState }) => {
        const response = await apiInstance
            .get(`${serviceName}/v1/extra/orders/qr-code/${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    },
);
export const GetSummaryById = createAsyncThunk('extraMeal/GetSummaryById ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v2/summary/get-by-id/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetStatusByUserIdActive = createAsyncThunk(
    'extraMeal/getStatusByUserIdActive',
    async ({ userId, isHistory }, { rejectWithValue }) => {
        try {
            const response = await apiInstance.get(
                `${serviceName}/v2/extra/orders/active-statuses/${userId}/${isHistory}`
            );
            return { data: response.data, status: response.status };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const GetStatusByUserIdHistory = createAsyncThunk('extraMeal/GetStatusByUserIdHistory ', async (userId, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v1/extra/orders/history-statuses/${userId}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetQr = createAsyncThunk('extraMeal/GetQr ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${serviceName}/v2/orders/qr-code/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});


export const GetFoodieApprovalByRequestMealId = createAsyncThunk('extraMeal/getFoodieApprovalByRequestMealId ', async (id, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`foodie-menu-service/v2/foodie-approval/user-menu-id/${id}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
